import React from 'react';
import PropTypes from 'prop-types';
import LiveTile from './views/Carousel/LiveTile';
import SeasonTile from './views/Carousel/SeasonTile';
import ClipTile from './views/Carousel/ClipTile';
import SeeAllTile from './views/Carousel/SeeAllTile';
import SearchTile from './views/Grid/SearchTile';

const LIVE_TILE = 'live';
const SEARCH_TILE = 'search';
const SERIES_CLIP_TILE = 'seriesClip';
const SERIES_SEASON_TILE = 'seriesSeason';
const SEE_ALL_TILE = 'seeMore';

const Tile = ({ type, ...rest }) => {
  const components = {
    [LIVE_TILE]: LiveTile,
    [SEARCH_TILE]: SearchTile,
    [SEE_ALL_TILE]: SeeAllTile,
    [SERIES_CLIP_TILE]: ClipTile,
    [SERIES_SEASON_TILE]: SeasonTile,
  };
  if (!type) return null;
  const Component = components[type];
  if (!Component) return null;
  return <Component type={type} {...rest} />;
};

Tile.propTypes = { type: PropTypes.string.isRequired };

export { LIVE_TILE, SEE_ALL_TILE, SEARCH_TILE, SERIES_CLIP_TILE, SERIES_SEASON_TILE, Tile };
